const { onlyAlphaNumeric, SPACE, COMMA } = require('../helpers');

exports.zipCodeNormalize = (zipCode) => {
  if (!zipCode) {
    return zipCode;
  }
  const zip = onlyAlphaNumeric(zipCode);
  if (zipCode.length <= 2) {
    return zip;
  }
  return `${zip.slice(0, 2).toUpperCase()}-${zip.slice(2, 6)}`;
};

exports.countryDefinition = {
  country: 'Latvia',
  code: 'LV',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Street Address' },
    address2: { label: 'Street Address 2' },
    city: { label: 'Post Office', width: 0.5 },
    zipCode: {
      label: 'Postcode',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  viewFormat: [
    ['company'],
    ['address', COMMA, 'address2'],
    ['city', SPACE, 'zipCode']
  ],
  formFormat: [['company'], ['address'], ['address2'], ['city', 'zipCode']],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(/^LV-[0-9]{4}$/),
      error: 'Must be LV + 4 numbers, LV-1073'
    }
  ]
};
